import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLoading } from '../global';
import axios from 'axios';
import { bearerAuth } from '../auth';
import { ServiceForm } from '../services';
import { BackendSortParams, OrderEnum } from '../../../components';
import { addQueryParam } from '../slice';

export const getServices = createAsyncThunk(
    'services/getServices', ({jwtToken, page = 0, pageSize = 100, sortParameters}: {
        jwtToken?: string,
        page?: number,
        pageSize?: number,
        sortParameters?: BackendSortParams
    }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        // let url = '/manage/services?page=' + params.page + '&size=' + params.pageSize + "&sort=" + params.sortParameters.field + "," + OrderEnum[params.sortParameters.order]
        var url = '/manage/services';
        url = addQueryParam(url, 'page', page);
        url = addQueryParam(url, 'size', pageSize);
        if (sortParameters != undefined) {
            url = url + "&sort=" + sortParameters.field + "," + OrderEnum[sortParameters.order]
        }

        return axios.get(url, config)
            .then(response => response.data)
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const getService = createAsyncThunk(
    'services/getService', ({jwtToken, serviceExternalKey}: { jwtToken: string, serviceExternalKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.get('/manage/services/' + serviceExternalKey, config)
            .then(response => response.data)
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const saveService = createAsyncThunk(
    'services/saveService', ({jwtToken, serviceForm}: { jwtToken: string, serviceForm: ServiceForm }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };
        const body = {
            externalKey: serviceForm.externalKey,
            name: serviceForm.name,
            reportingBucketSize: serviceForm.reportingBucketSize,
            reportingBucketPeriodInMinutes: serviceForm.reportingBucketPeriodInMinutes,
            reportingBucketMarginInMinutes: serviceForm.reportingBucketMarginInMinutes,
            administratorEmailAddresses: serviceForm.administratorEmailAddresses,
            additionalUserEmailAddresses: serviceForm.additionalUserEmailAddresses,
            base64EncodedLogo: serviceForm.base64EncodedLogo,
            location: serviceForm.location,
            allowedIssueTypes: serviceForm.allowedIssueTypes,
            allowedImpactTypes: serviceForm.allowedImpactTypes,
            serviceProfiles: serviceForm.serviceProfiles,
            showInApp: serviceForm.showInApp
        };

        return axios.post('/manage/services', body, config)
            .then(response => response.data)
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);
